/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { DateFormatOptions } from "./DateFormatOptions";
import { defaultLocale, defaultTimezone } from "./constants";

/**
 * Converts given UTC date time to the local date using the provided options.
 * @example "May 8, 2021"
 * @param date The date-time to convert.
 * @param options The options for formatting the date.
 * @returns The formatted local date.
 */
export const toLocalDate = (date: Date, options: DateFormatOptions): string => {
    const { locale, timeZone } = options;

    return Intl.DateTimeFormat(locale ? locale : defaultLocale, {
        day: "numeric",
        month: "long",
        timeZone: timeZone ? timeZone : defaultTimezone,
        year: "numeric"
    }).format(date);
};
